"use strict";

function isDate(value) {
    return value instanceof Date;
}

module.exports = isDate;
